// extracted by mini-css-extract-plugin
export default {"separator":"select_separator_separator__0sl-k"};